//#region import
import React, { Fragment, createContext, useContext, useEffect, useRef, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Grid, Typography } from '@mui/material';
import { BtnCancel, BtnDraft, BtnEdit, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import FroalaEditor from 'react-froala-wysiwyg';
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import 'froala-editor/js/languages/th';
import AccordionPanel from '../components/AccordionPanel';
import { useLocation } from 'react-router';
import ContentWrapper from '../components/ContentWrapper';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
//#endregion

const Panel2 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [sObjectiveDesc, setsObjectiveDesc] = useState(null);   
    const [sObjectiveTarget, setsObjectiveTarget] = useState(null); 

    const ref_sObjectiveDesc = useRef<any>(null);
    const ref_sObjectiveTarget = useRef<any>(null);

    const configs = (placeholderText) => {
        let ObjConfigs = {
            key: "0BA3jA11B5C7C4A4D3aIVLEABVAYFKc2Cb1MYGH1g1NYVMiG5G4E3C3A1C8A6D4A3B4==",
            attribution: false,
            heightMin: 200,
            heightMax: 2000,
            imageUploadURL: process.env.REACT_APP_API_URL + "api/UploadFile/UploadFileFroala",
            // quickInsertButtons: ['image', 'table', 'ol', 'ul', 'myButton'],
            // pluginsEnabled: ['quickInsert', 'image', 'table', 'lists'],
            placeholderText: placeholderText,
            language: 'th',
            toolbarButtons: {
                moreText: {
                    buttons: ['bold', 'italic', 'underline', 'subscript', 'superscript', 'fontSize', 'textColor', 'clearFormatting']
                },
                moreParagraph: {
                    buttons: ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify'],
                    buttonsVisible: 4
                },
                moreRich: {
                    buttons: ['insertTable', 'insertImage', 'insertHR']
                },
                moreMisc: {
                    buttons: ['undo', 'redo', 'fullscreen'],
                    align: 'right',
                    buttonsVisible: 3
                }
            },
            quickInsertButtons: ['table', 'image', 'hr'],
            pasteAllowedStyleProps : ['color'], //'font-size', 
            imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove'],
            charCounterCount: false,
        }
        return ObjConfigs;
    };

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel2, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            setsObjectiveDesc(result.objResult.sObjectiveDesc);
            setsObjectiveTarget(result.objResult.sObjectiveTarget);

            if (ref_sObjectiveDesc.current) ref_sObjectiveDesc.current.props.onModelChange(result.objResult.sObjectiveDesc ?? "");
            if (ref_sObjectiveTarget.current) ref_sObjectiveTarget.current.props.onModelChange(result.objResult.sObjectiveTarget ?? "");
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (nModeID === EnumSaveModeProject.Submit && (sObjectiveDesc === null || sObjectiveDesc === "") && (sObjectiveTarget === null || sObjectiveTarget === "")) {
            return DialogFn.Warning("กรุณากรอกข้อมูลให้ครบถ้วน");
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel2,
            isFastTrack: isFastTrack,

            sObjectiveDesc : sObjectiveDesc,
            sObjectiveTarget : sObjectiveTarget,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft 
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel2, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 2, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"2. วัตถุประสงค์และเป้าหมาย"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivPanel2"} item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                {/* Subject 1 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>2.1 วัตถุประสงค์</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' color={'red'}>*</Typography>
                        </Grid>                        
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                model={sObjectiveDesc}
                                onModelChange={setsObjectiveDesc}
                                // tag='textarea'
                                config={configs("ต้องมีความเป็นไปได้และสามารถดําเนินการได้จริงในระยะเวลาที่ขอสนับสนุน")}
                                ref={ref_sObjectiveDesc}
                            />
                            :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView 
                                    // tag='div'
                                    model={sObjectiveDesc} 
                                />
                            </ContentWrapper> 
                        }
                    </Grid>
                </Grid>
                {/* Subject 2 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>2.2 เป้าหมาย</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' color={'red'}>*</Typography>
                        </Grid>                        
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                model={sObjectiveTarget}
                                onModelChange={setsObjectiveTarget}
                                // tag='textarea'
                                config={configs("ต้องสอดคล้องกับปัญหาและวัตถุประสงค์ โดยระบุเป็นประเภท ลักษณะและปริมาณ ในรูปแบบตัวเลขหรือจํานวนที่จะทําได้ภายในระยะเวลาที่ขอสนับสนุน")}
                                ref={ref_sObjectiveTarget}
                            />
                            :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView 
                                    // tag='div'
                                    model={sObjectiveTarget} 
                                />
                            </ContentWrapper> 
                        }
                    </Grid>
                </Grid>                   
            </Grid>
            {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                <></>
                :
                (isPermission === true &&
                    (isModeSecretary !== true ?
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                            {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                <Grid item>
                                    <BtnDraft id={"btnDraft_Panel2"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                </Grid>
                            }
                            <Grid item>
                                <BtnSendRequest id={"btnSend_Panel2"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => {handleSubmit(EnumSaveModeProject.Submit) }} />
                            </Grid> 
                        </Grid>
                    : 
                        (isModeSecretary === true ?
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {isEditSecretary === false ?
                                    <Grid item>
                                        <BtnEdit id={"btnEdit_Panel2"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel2").scrollIntoView({ behavior: "smooth" }); }} />
                                    </Grid>
                                    :
                                    <>
                                        <Grid item>
                                            <BtnCancel id={"btnCancel_Panel2"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel2"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                        </Grid>
                                    </>
                                }   
                            </Grid>
                            : <></>
                        )
                    )
                )
            }
        </AccordionPanel>
    )
}
export default Panel2;
